import React, { FC } from 'react';
import {
  LedBuildingActiveIcon,
  LedBuildingIcon,
  LedLocationActiveIcon,
  LedLocationIcon,
  LedOrderActiveIcon,
  LedOrderIcon,
  LedSearchActiveIcon,
  LedSearchIcon,
  LedSummaryActiveIcon,
  LedSummaryIcon,
} from 'assets/svgs/led';
import {
  LED_BUILDING_INFO_ROUTE,
  LED_PROJECT_INTRO_ROUTE,
  LED_PLACE_ORDER_ROUTE,
  LED_PROJECT_SUMMARY_ROUTE,
  LED_SELECT_REPLACEMENTS_ROUTE,
} from 'config/led/routes';
import { useRouter } from 'next/router';
import { LedNavList } from 'components/led/atoms';
import { LedNavigationItem } from 'components/led/structures';
import ledStores from 'stores/led';

const navList = [
  {
    route: LED_PROJECT_INTRO_ROUTE,
    text: 'Project intro',
    icons: {
      main: <LedLocationIcon />,
      active: <LedLocationActiveIcon />,
    },
  },
  {
    route: LED_BUILDING_INFO_ROUTE,
    text: 'Building info',
    icons: {
      main: <LedBuildingIcon />,
      active: <LedBuildingActiveIcon />,
    },
  },
  {
    route: LED_SELECT_REPLACEMENTS_ROUTE,
    text: 'Select replacements',
    icons: {
      main: <LedSearchIcon />,
      active: <LedSearchActiveIcon />,
    },
  },
  // { this step will be in the future
  //   route: LED_PROJECT_SUMMARY_ROUTE,
  //   text: 'Project summary',
  //   icons: {
  //     main: <LedSummaryIcon />,
  //     active: <LedSummaryActiveIcon />,
  //   },
  // },
  {
    route: LED_PLACE_ORDER_ROUTE,
    text: 'Place order',
    icons: {
      main: <LedOrderIcon />,
      active: <LedOrderActiveIcon />,
    },
  },
];

const LedMenu: FC = () => {
  const router = useRouter();
  const { ledLayoutStore } = ledStores;
  const { isValidSession } = ledLayoutStore;

  const goTo = (route: string) => () => {
    if (isValidSession(route)) {
      (async () => {
        await router.push(route);
      })();
    }
  };

  return (
    <LedNavList>
      {navList.map((item) => (
        <LedNavigationItem
          key={item.route}
          item={item}
          isActive={router.asPath === item.route}
          onClick={goTo(item.route)}
        />
      ))}
    </LedNavList>
  );
};

export default LedMenu;
